import observer from 'saddlebag-observer';

const GA_TRACK_EVENT = 'ga-track-event-with-page-name' as const;

type GaEventPayload = {
  category: string;
  label: string;
  action: string;
  value?: number;
};

const logGaEvent = (
  category: string,
  label: string,
  action: string,
  value?: number,
): void => {
  const payload: GaEventPayload = {
    category,
    label,
    action,
    value,
  };
  observer.publish(GA_TRACK_EVENT, payload);
};

export default logGaEvent;
